<template>
	<div class="list-icon-item" @click="routerTo">
		<div class="icon"><slot name="icon"></slot></div>
		{{ label }}
	</div>
</template>

<script>
	export default {
		name: 'iconList',
		props: {
			label: {
				type: String,
				default: ''
			},
			linkUrl: {
				type: String,
				default: '/'
			},
			queryParams: {
				style: Object,
				default: () => {}
			},
		},
		methods: {
			routerTo() {
				if (this.linkUrl && this.linkUrl !== '/') {
				    this.$router.push({
						path:this.linkUrl,
						query: this.queryParams,
					});
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.list-icon-item {
		width: 25%;
		color: #666666;
		font-size: .28rem;
		text-align: center;
		margin-bottom: .25rem;
		.icon {
			width: .6rem;
			height: .6rem;
			margin: 0 auto;
			margin-bottom: .08rem;
			img {
				display: block;
				width: 100%;
			}
		}
	}
</style>
